import React, { useCallback } from "react";
import { Button, Modal } from "antd";
import { observer } from "mobx-react";
import { BUTTONS, MODAL } from "../../constants/translates";
import { Clear } from "../../interfaces/common";
import Authorize from "../Authorize";
import { DELETE_DECLARANT } from "../../constants/authorize";

interface Props {
  store: Clear;
}

const ClearButton: React.FC<Props> = ({ store }) => {
  const showModalHandler = useCallback(() => {
    Modal.confirm({
      onOk: () => {
        store.clear();
      },
      title: MODAL.confirm_title,
      content: MODAL.confirm_clear,
    });
  }, [store]);

  return (
    <Authorize permission={[DELETE_DECLARANT]}>
      <Button
        type="primary"
        onClick={showModalHandler}
        disabled={store.data.length === 0}
        size="small"
      >
        {BUTTONS.clearTable}
      </Button>
    </Authorize>
  );
};

export default observer(ClearButton);
